import React from "react";

const ErrorPage = () => {
  return (
    <div>
      <h1>Nothing Found</h1>
    </div>
  );
};

export default ErrorPage;
